import { createContext } from 'react';

import { Cache } from '../../libs/cache';

export const CacheContext = createContext<Cache | null>(null);
